
import * as actions from 'actions';

const INITIAL_STATE = {
  selectedTab: '',
  isFetching: false
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.SEARCH_ITEMS_FETCH:
      return {...state, selectedTab: '', isFetching: true};

    case actions.SEARCH_ITEMS_FETCH_ERROR:
      return {...state, isFetching: false};

    case actions.SEARCH_RESULTS_RECEIVED: {
      const hasItems = action.result.meta.count > 0;
      const tabFromAction = hasItems ? action.query.category : state.selectedTab;
      const selectedTab = state.selectedTab || tabFromAction;
      return {
        ...state,
        isFetching: false,
        selectedTab
      };
    }

    case actions.SEARCH_CHANGE_TAB:
      return {...state, selectedTab: action.tab};

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/search/tabs/reducer.js
 **/